<template>
  <div
    class="user-library"
    data-test="user-library">
    <login-message v-if="!isLoggedIn"/>
    <el-row
      v-if="isLoggedIn">
      <el-col
        :span="24"
        class="d-flex-center">
        <el-menu
          :router="true"
          mode="horizontal"
          class="el-menu-demo">
          <el-menu-item
            :class="matchRoute('/listen/my-shows') || matchRoute('/listen/my-shows/list') ? 'is-active' : ''"
            @click="$router.push('/listen/my-shows')">
            <span slot="title">Shows</span>
          </el-menu-item>
          <el-menu-item
            :class="matchRoute('/listen/bookmarks') ? 'is-active' : ''"
            @click="$router.push('/listen/bookmarks')">
            <span slot="title">Bookmarks</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
    <router-view />
  </div>
</template>
<script>
import LoginMessage from '../../components/LoginMessage';

export default {
  name: 'UserLibrary',
  components: {
    'login-message': LoginMessage,
  },
  data() {
    return {
      isLoggedIn: this.$store.getters.loggedIn,
    };
  },
  methods: {
    matchRoute(route) {
      return this.$route.path.includes(route);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";
.user-library {
  margin: 35px 0;

  .is-active {
    border-bottom: 2px solid $blue !important;
    font-weight: bold;
    span {
      color: $blue !important;
    }
  }
  .el-menu-item {
    font-size: 20px !important;
    padding: 0 80px;
    color: #bbb;
    background-color: #FEFEFC;
  }
  .el-menu--horizontal {
    border-bottom: 0 !important;
  }
}
@media (max-width: 576px) {
  .el-menu--horizontal {
    li {
      padding:0 50px !important;
    }
  }
}
@media (max-width: 375px) {
  .el-menu--horizontal {
    li {
      padding:0 30px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/user_library/Index.vue